import { render, staticRenderFns } from "./CompanyNote.vue?vue&type=template&id=5b04b523&lang=pug"
import script from "./CompanyNote.vue?vue&type=script&lang=js"
export * from "./CompanyNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports